import PropTypes from 'prop-types';
import React from 'react';
import SelectSearch from '../SelectSearch';
import SelectSearchList from '../SelectSearchList';
export default function SelectOptions(_ref) {
  var showSearch = _ref.showSearch,
      onSearch = _ref.onSearch,
      searchValue = _ref.searchValue,
      searchLoading = _ref.searchLoading,
      empty = _ref.empty,
      children = _ref.children;
  return showSearch ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectSearch, {
    value: searchValue,
    onChange: function onChange(value) {
      onSearch(value);
    }
  }), /*#__PURE__*/React.createElement(SelectSearchList, {
    loading: searchLoading,
    empty: empty
  }, children)) : empty || searchLoading ? /*#__PURE__*/React.createElement(SelectSearchList, {
    loading: searchLoading,
    empty: empty
  }) : children;
}
SelectOptions.propTypes = {
  onSearch: PropTypes.func,
  showSearch: PropTypes.bool,
  children: PropTypes.node,
  searchValue: PropTypes.string,
  searchLoading: PropTypes.bool,
  empty: PropTypes.bool
};
SelectOptions.defaultProps = {
  onSearch: function onSearch() {},
  showSearch: false,
  children: null,
  searchValue: '',
  searchLoading: false,
  empty: false
};